import React, { useEffect, useRef, useState } from "react";
import Isotope from "isotope-layout";
import ProjectDetailsModal from "./ProjectDetailsModal";
const Portfolio = ({ classicHeader, darkTheme }) => {
  // init one ref to store the future isotope object
  const isotope = useRef();
  // store the filter keyword in a state
  const [filterKey, setFilterKey] = useState("*");
  const [imagesLoaded, setimagesLoaded] = useState(0);
  const [selectedProjectDetails, setSelectedProjectDetails] = useState();

  const filters = {
    VIDEOS: "Videos",
    GIT: "GIT",
  };

  const projectsData = [
    {
      title: "PYTHON/DJANGO Website",
      projectInfo:
        "Python/Django Web Application setup for learning and exploring",
      client: "Own",
      technologies: "Python Django, HTML5, CSS3, JavaScript",
      industry: "Web Development",
      date: "April, 2020",
      url: {
        name: "Ads Site",
        link: "http://ifran.pythonanywhere.com/",
      },
      socialLinks: {
        // facebook: "http://www.facebook.com/",
        // twitter: "http://www.twitter.com/",
        // google: "http://www.google.com/",
        // instagram: "http://www.instagram.com/",
        // mail: "mailto:example@gmail.com",
        github: "https://github.com/ifranaiyubali/django_ads_list",
      },
      thumbImage: process.env.PUBLIC_URL + "/images/projects/ADS.JPG",
      sliderImages: [process.env.PUBLIC_URL + "/images/projects/ADS_1.png"],
      categories: [filters.GIT],
    },
    {
      title: "Religious Calendar App",
      projectInfo:
        "Python/Django Web Application setup for learning and exploring. Setup Islamic calendar with religious events and reminders.",
      client: "Own",
      technologies: "Python Django, HTML5, CSS3, JavaScript",
      industry: "Web Development",
      date: "January, 2022",
      url: {
        name: "Isalamic Calendar",
        link: "https://ifranali.pythonanywhere.com/",
      },
      socialLinks: {
        // facebook: "http://www.facebook.com/",
        // twitter: "http://www.twitter.com/",
        // google: "http://www.google.com/",
        // instagram: "http://www.instagram.com/",
        // mail: "mailto:example@gmail.com",
      },
      thumbImage: process.env.PUBLIC_URL + "/images/projects/Islamic_Calender.png",
      sliderImages: [process.env.PUBLIC_URL + "/images/projects/Islamic_Calender_1.png"],
      categories: [],
    },
    {
      title: "Driving School Management System",
      projectInfo:
        "Driving School Management System using WordPress with custom plugins and themes.",
      client: "yaas Driving School",
      technologies: "WordPress, PHP, HTML5, CSS3, JavaScript",
      industry: "Driving School",
      date: "January 1, 2025",
      url: {
        name: "Eliyaas Driving School",
        link: "https://eliyaasdrivingschool.com.au/",
      },
      socialLinks: {
        // facebook: "http://www.facebook.com/",
        // twitter: "http://www.twitter.com/",
        // google: "http://www.google.com/",
        // instagram: "http://www.instagram.com/",
        // mail: "mailto:example@gmail.com",
      },
      thumbImage: process.env.PUBLIC_URL + "/images/projects/Driving_School.png",
      sliderImages: [process.env.PUBLIC_URL + "/images/projects/Driving_School_1.png"],
      categories: [],
    },
    {
      title: "Cacti",
      projectInfo:
        "While working for Vinod Patel & Company Limited we were exploring and analysing very good software for monitoring network devices when we came across Cacti. We then tried the open source software and to see if it suited the company requirements. The freeware then became part of network monitoring suits.",
      client: "Vinod Patel Company",
      technologies: "Cacti, RRDTool, PHP, MySQL",
      industry: "Network Monitoring",
      date: "July 23, 2016",
      url: {
        name: "CACTI",
        link: "https://youtu.be/eGCiT-HPpJw",
      },
      socialLinks: {
        // facebook: "http://www.facebook.com/",
        // twitter: "http://www.twitter.com/",
        // google: "http://www.google.com/",
        // instagram: "http://www.instagram.com/",
        // mail: "mailto:example@gmail.com",
      },
      thumbImage: process.env.PUBLIC_URL + "/images/projects/CactiTool.jpg",
      sliderImages: [],
      categories: [filters.VIDEOS],
    },
    {
      title: "Replicating a WordPress Website",
      projectInfo:
        "The Project was one of the last projects i did with Mana Island Resort & Spa, while i was working there. Basically the project required an exact replica of Word Press build website to be hosted on a local Server. The Website being the offical website for Mana Island Resort & Spa. The project required the website to to be hosted locally so the manitanence could be carried on the replica, then this would exported once completed. All this while current web services for Mana Island Resort & Spa would not affected. The Project involved exporting the website which was easy enough, with the build in feature for Word Press however the main conundrum setting up the locally hosted machine",
      client: "Mana Island Resort & Spa.",
      technologies: "WORDPRESS, HTML5, CSS3, PHP, JavaScript",
      industry: "Hospitality",
      date: "January 1, 2015",
      url: {
        name: "WordPress Website",
        link: "https://youtu.be/Kbnt8eHgXDE",
      },
      socialLinks: {
        // facebook: "http://www.facebook.com/",
        // twitter: "http://www.twitter.com/",
        // google: "http://www.google.com/",
        // instagram: "http://www.instagram.com/",
        // mail: "mailto:example@gmail.com",
      },
      thumbImage:
        process.env.PUBLIC_URL + "/images/projects/Mana_Wordpress.png",
      sliderImages: [],
      categories: [filters.VIDEOS],
    },

    {
      title: "Squid 3.3.8 https restrictions Setup",
      projectInfo:
        "Quidam lisque persius interesset his et, in quot quidam persequeris vim, ad mea essent possim iriure. Lisque persius interesset his et, in quot quidam persequeris vim, ad mea essent possim iriure.",
      client: "Mana Island Resort & Spa",
      technologies: "SQUID, LINUX, FIREWALLS",
      industry: "Hospitality",
      date: "July 16, 2014",
      url: {
        name: "SQUID Proxy",
        link: "https://youtu.be/th3rS-QHYSo",
      },
      socialLinks: {
        // facebook: "http://www.facebook.com/",
        // twitter: "http://www.twitter.com/",
        // google: "http://www.google.com/",
        // instagram: "http://www.instagram.com/",
        // mail: "mailto:example@gmail.com",
      },
      thumbImage: process.env.PUBLIC_URL + "/images/projects/Squid_Proxy.png",
      sliderImages: [],
      categories: [filters.VIDEOS],
    },
  ];

  // initialize an Isotope object with configs
  useEffect(() => {
    isotope.current = new Isotope(".portfolio-filter", {
      itemSelector: ".filter-item",
      layoutMode: "masonry",
    });

    // cleanup
    return () => {
      isotope.current.destroy();
    };
  }, []);

  // handling filter key change
  useEffect(() => {
    if (imagesLoaded) {
      filterKey === "*"
        ? isotope.current.arrange({ filter: `*` })
        : isotope.current.arrange({ filter: `.${filterKey}` });
    }
  }, [filterKey, imagesLoaded]);

  const handleFilterKeyChange = (key) => () => setFilterKey(key);

  return (
    <>
      <section
        id="portfolio"
        className={"section " + (darkTheme ? "bg-dark-2" : "bg-light")}
      >
        <div className={"container " + (classicHeader ? "" : "px-lg-5")}>
          {/* Heading */}
          <div className="position-relative d-flex text-center mb-5">
            <h2
              className={
                "text-24  text-uppercase fw-600 w-100 mb-0 " +
                (darkTheme ? "text-muted opacity-1" : "text-light opacity-4")
              }
            >
              Portfolio
            </h2>
            <p
              className={
                "text-9 text-dark fw-600 position-absolute w-100 align-self-center lh-base mb-0 " +
                (darkTheme ? "text-white" : "text-dark")
              }
            >
              {" "}
              My Work
              <span className="heading-separator-line border-bottom border-3 border-primary d-block mx-auto" />
            </p>
          </div>
          {/* Heading end*/}
          {/* Filter Menu */}
          <ul
            className={
              "portfolio-menu nav nav-tabs justify-content-center border-bottom-0 mb-5 " +
              (darkTheme ? "nav-light" : "")
            }
          >
            <li className="nav-item">
              <button
                className={"nav-link " + (filterKey === "*" ? "active" : "")}
                onClick={handleFilterKeyChange("*")}
              >
                All
              </button>
            </li>
            {Object.keys(filters).map((oneKey, i) => (
              <li className="nav-item" key={i}>
                <button
                  className={
                    "nav-link " +
                    (filterKey === filters[oneKey] ? "active" : "")
                  }
                  onClick={handleFilterKeyChange(filters[oneKey])}
                >
                  {filters[oneKey]}
                </button>
              </li>
            ))}
          </ul>
          {/* Filter Menu end */}
          <div className="portfolio popup-ajax-gallery">
            <div className="row portfolio-filter filter-container g-4">
              {projectsData.length > 0 &&
                projectsData.map((project, index) => (
                  <div
                    className={
                      "col-sm-6 col-lg-4 filter-item " +
                      project.categories.join(" ")
                    }
                    key={index}
                  >
                    <div className="portfolio-box rounded">
                      <div className="portfolio-img rounded">
                        <img
                          onLoad={() => {
                            setimagesLoaded(imagesLoaded + 1);
                          }}
                          className="img-fluid d-block portfolio-image"
                          src={project.thumbImage}
                          alt=""
                        />
                        <div className="portfolio-overlay">
                          <a
                            className="popup-ajax stretched-link"
                            href=""
                            onClick={() => {
                              setSelectedProjectDetails(projectsData[index]);
                            }}
                            data-bs-toggle="modal"
                            data-bs-target="#exampleModal"
                          />
                          <div className="portfolio-overlay-details">
                            <h5 className="text-white fw-400">
                              {project.title}
                            </h5>
                            <span className="text-light">Category</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </section>
      <div className="project-details-modal">
        {/* Modal */}
        <ProjectDetailsModal
          projectDetails={selectedProjectDetails}
          darkTheme={darkTheme}
        ></ProjectDetailsModal>
      </div>
    </>
  );
};

export default Portfolio;
